var $ = require('jquery');

$(function () {
    $('.tabbed-section-navigation').each(function () {
        var t = $(this);

		// desktop tabs init
		t.find('.tabbed-section-navigation__tabs__tab__name').eq(0).addClass('selected');
		$('.tabbed-section-navigation__tab-content__group').eq(0).children('.tabbed-section-navigation__tab-content__item').addClass('selected').removeAttr("style");

		// mobile accordion init
		if (window.innerWidth <= 767) {
			$('.tabbed-section-navigation__tab-content__group').children('.tabbed-section-navigation__tab-content__item').removeClass('selected');
		}

        function changeTab(prevTab, nextTab) {
            if (prevTab !== nextTab) {
                //update content/slider tabs
                t.find('.tabbed-section-navigation__tab-content__item[data-tab-id="' + nextTab + '"]').addClass('selected');
                t.find('.tabbed-section-navigation__tab-content__item[data-tab-id="' + prevTab + '"]').removeClass('selected');

                //update desktop tabs
                var prevDesktop = t.find('.tabbed-section-navigation__tabs__tab__name[data-tab-id=' + prevTab + ']');
                var nextDesktop = t.find('.tabbed-section-navigation__tabs__tab__name[data-tab-id=' + nextTab + ']');
                prevDesktop.removeClass('selected');
                prevDesktop.parent().removeClass('selected');
                nextDesktop.addClass('selected');
                nextDesktop.parent().addClass('selected');
            }
        }

        // desktop tabs
        t.find('.tabbed-section-navigation__tabs__tab').eq(0).addClass('selected');

		t.find('.tabbed-section-navigation__tabs__tab__name').click(function (e) {
			var dataId = $(this).attr('data-tab-id');
			e.preventDefault();
			var prev = t.find('.tabbed-section-navigation__tab-content__item.selected').attr('data-tab-id');
			changeTab(prev, dataId);
		});

		// accordion event mobile
		$('.tabbed-section-navigation__tab-content__group .tabbed-section-navigation__tab-content__name').on('click', function (e) {
			e.preventDefault();
			var newAccordionItem = $('.tabbed-section-navigation__tab-content');
			$.AnimatedScroll(newAccordionItem.offset().top, 400);

			$(this).parent().siblings('.tabbed-section-navigation__tab-content__group')
				.children('.tabbed-section-navigation__tab-content__name').removeClass('selected').removeClass('last-selected')
				.next('.tabbed-section-navigation__tab-content__item').slideUp();
			$(this).toggleClass('selected').next('.tabbed-section-navigation__tab-content__item').slideToggle();

			if (newAccordionItem.find('.selected').length == 0) {
				$(this).addClass('last-selected');
			}
		});


        // resize event from tabs to accordion or vice-versa.
		$(window).on('resize orientationchange', function () {

			$('.tabbed-section-navigation__tabs').children('.tabbed-section-navigation__tabs__tab').removeClass('selected');
			$('.tabbed-section-navigation__tabs').children('.tabbed-section-navigation__tabs__tab').eq(0).addClass('selected');

			if (window.innerWidth > 767) {
				$('.tabbed-section-navigation__tab-content').children('.tabbed-section-navigation__tab-content__group').find('.tabbed-section-navigation__tab-content__item').removeClass('selected').removeAttr("style");
				$('.tabbed-section-navigation__tab-content').children('.tabbed-section-navigation__tab-content__group').eq(0).find('.tabbed-section-navigation__tab-content__item').addClass('selected').removeAttr("style");
			} else {
				$('.tabbed-section-navigation__tab-content').children('.tabbed-section-navigation__tab-content__group').find('.tabbed-section-navigation__tab-content__name').removeClass('selected')
				$('.tabbed-section-navigation__tab-content').children('.tabbed-section-navigation__tab-content__group').find('.tabbed-section-navigation__tab-content__item').removeClass('selected')
			}

		});

    });

});